import { useCallback } from 'react';
import { useClients } from '../clients';
import { useFilterContext } from '../filter-context';
const CONFLUENCE_ADVANCED_SEARCH_URL = '/wiki/search';

// Only-for-testing
export const confluenceAdvancedSearchUrl = (query, spaceFilterIds, contributorFilterIds, siteUrl = '', lastModified = '') => {
  const trimmedSiteUrl = removeDuplicateWikiInUrl(siteUrl);
  const trimmedQuery = query.trim();
  if (!trimmedQuery && !lastModified) {
    return `${trimmedSiteUrl}${CONFLUENCE_ADVANCED_SEARCH_URL}`;
  }
  const spaceFilter = spaceFilterIds.length > 0 ? `&spaces=${encodeURIComponent(spaceFilterIds.join(','))}` : '';
  const contributorFilter = contributorFilterIds.length > 0 ? `&contributors=${encodeURIComponent(contributorFilterIds.join(','))}` : '';
  const prequeryDateFilter = !!lastModified ? `&lastModified=custom&from=${lastModified}` : '';
  return `${trimmedSiteUrl}${CONFLUENCE_ADVANCED_SEARCH_URL}?text=${encodeURIComponent(trimmedQuery)}${spaceFilter}${contributorFilter}${prequeryDateFilter}`;
};
export const useConfluenceAdvancedSearchUrlFactory = () => {
  return useCallback((query, siteUrl, spaceFilters, peopleFilters, lastModified = '') => confluenceAdvancedSearchUrl(query, spaceFilters.filter(f => f.isChecked).map(f => f.id), peopleFilters.filter(f => f.isChecked).map(f => f.id), siteUrl, lastModified), []);
};

/**
 * An advanced search link URL factory which uses the most relevant site to generate an advanced search link
 * If the dialog is searching multiple sites, this factory picks the first site to generate an advanced search link to
 * (as is the implementation of the client context)
 */
export const usePrimarySiteConfluenceAdvancedSearchUrlFactory = () => {
  const {
    siteUrl
  } = useClients();
  const {
    spaceFilters: {
      availableFilters: availableSpaceFilters
    },
    peopleFilters: {
      availableFilters: availablePeopleFilters
    },
    prequeryFiltersRef
  } = useFilterContext();
  const factory = useConfluenceAdvancedSearchUrlFactory();
  return useCallback(query => factory(query, siteUrl, availableSpaceFilters, availablePeopleFilters, prequeryFiltersRef.current), [availablePeopleFilters, availableSpaceFilters, prequeryFiltersRef, factory, siteUrl]);
};
const removeDuplicateWikiInUrl = siteUrl => {
  return siteUrl.replace(/\/wiki(\/)?$/, '');
};